import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
  inject,
  input,
} from '@angular/core';
import { Client } from 'src/app/shared/types/client';
import { GameType } from 'src/app/shared/types/game-type';
import {
  GAME_NAME_MAPPER,
  GAME_ICON_MAPPER,
  GAME_ORDER_MAPPER,
} from '@shared/consts/game.consts';
import { UserRole } from '@shared/types/user';
import { SessionService } from '@services/session.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent {
  private session = inject(SessionService);

  isMobile = input(false);
  isSidenavOpen = input<boolean>();
  @Input() clients: Client[] = [];
  @Input() gameType!: GameType;
  @Input() userRole?: UserRole;
  @Input() isLoading?: boolean;

  @Output() toggleMenu = new EventEmitter<void>();
  @Output() addClient = new EventEmitter<void>();
  @Output() setClient = new EventEmitter<Client>();
  @Output() setGameType = new EventEmitter<GameType>();

  readonly types = GameType;
  readonly roles = UserRole;

  client$ = this.session.client$;
  games$ = this.session.userGames$.pipe(
    map((games) =>
      (games || [])
        .map((game) => ({
          type: game,
          icon: GAME_ICON_MAPPER[game],
          title: GAME_NAME_MAPPER[game],
          position: GAME_ORDER_MAPPER[game],
        }))
        .sort((a, b) => a.position - b.position),
    ),
  );

  constructor() {}

  onAddClient(): void {
    this.addClient.emit();
  }

  onSetClient(client: Client) {
    this.setClient.emit(client);
  }

  onSetGameType(gameType: GameType) {
    this.setGameType.emit(gameType);
  }

  onToggleMenu(): void {
    this.toggleMenu.emit();
  }
}
